module.exports = __webpack_public_path__ + "static/media/36.f1f04078.jpg";